'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";

import Form from 'react-bootstrap/Form';

import HelpPopover from "@uw-it-sis/lib-react/lib/HelpPopover";

import scheduleBuilderDetailsStore from './ScheduleBuilderDetailsStore';

class ScheduleBuilderForm extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.store = scheduleBuilderDetailsStore;

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.store.updateAppliedFilters(e.target.name, e.target.checked);
    }

    render() {
        let formData = this.store.formData;

        let formHelp =
            <HelpPopover title="Included Sections" className="ms-2" placement="top">
                By default, Schedule Builder does not include closed sections and sections that conflict with your registered courses. It does include sections that require a faculty or add code, and independent study sections.
                Use these checkboxes to change what Schedule Builder includes when building your schedule options.
            </HelpPopover>;

        let pceHelp =
            <HelpPopover title="Professional & Continuing Education" placement="top">
                For more information about Professional & Continuing Education (PCE) courses, visit <a href="http://pce.uw.edu/" target="_blank">pce.uw.edu.</a>
            </HelpPopover>;

        let restrictedHelp =
            <HelpPopover title="Faculty/Add codes Required" placement="top">
                If this filter is selected, Schedule Builder will include sections that require faculty or add codes and/or independent study sections.
            </HelpPopover>

        return (
            <>
                <div className="d-flex align-items-center mb-3">
                    <strong>Include sections that...</strong>
                    {formHelp}
                </div>
                <Form.Check id="sb-include-restrictions">
                    <Form.Check.Input type="checkbox"
                                      name="showRestricted"
                                      checked={formData.appliedFilters.showRestricted}
                                      onChange={(e) => this.onChange(e)} />
                    <Form.Check.Label className="d-inline me-2 align-middle">
                        Require faculty/add codes
                    </Form.Check.Label>
                    {restrictedHelp}
                </Form.Check>
                <Form.Check id="sb-include-overlap"
                            name="showOverlapped"
                            type="checkbox"
                            label="Overlap with my registered sections"
                            checked={formData.appliedFilters.showOverlapped}
                            onChange={(e) => this.onChange(e)} />
                <Form.Check id="sb-include-closed"
                            name="showClosed"
                            type="checkbox"
                            label="Are currently closed"
                            checked={formData.appliedFilters.showClosed}
                            onChange={(e) => this.onChange(e)} />
                <Form.Check id="sb-include-pce">
                    <Form.Check.Input type="checkbox"
                                      name="showOtherInstitutes"
                                      checked={formData.appliedFilters.showOtherInstitutes}
                                      onChange={(e) => this.onChange(e)} />
                    <Form.Check.Label className="d-inline me-2 align-middle">
                        Are UW PCE sections
                    </Form.Check.Label>
                    {pceHelp}
                </Form.Check>
            </>
        );
    }
}

export default observer(ScheduleBuilderForm);